import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'frequencyText',
})
export class FrequencyTextPipe implements PipeTransform {
  transform(value: number): string {
    switch (value) {
      case 7: return 'weekly';
      case 14: return 'fortnightly';
      default: return 'unknown';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/frequency-text.pipe.ts